import React, {useRef, useState} from 'react';
import {message, Space} from 'antd';
import {Button} from 'antd';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import api from '../../services/api';
import ENDPOINTS from '../../constants/endpoints';
import {formatPath} from '../../constants/PathRoutes';
import {useConfirmModal} from '../../components/ConfirmModal';
import SearchTable from '../../components/admin/SearchTable';
import AddressModal from '../../components/shop/AddressModal';

export default function ShopAddresses() {
    const tableRef = useRef();
    const [modalOpen, setModalOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const {showConfirm, ConfirmModal: ConfirmModalComponent} = useConfirmModal();

    const openCreate = () => {
        setEditingRecord(null);
        setModalOpen(true);
    };

    const openEdit = (record) => {
        setEditingRecord(record);
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
        setEditingRecord(null);
    };

    const handleDelete = (record) => {
        showConfirm({
            title: 'Excluir endereço',
            description: 'Tem certeza que deseja excluir este endereço?',
            type: 'danger',
            onConfirm: async () => {
                await api.delete(formatPath(ENDPOINTS.AUTH_ADDRESS_DETAIL, {id: record.id}));
                message.success('Endereço excluído com sucesso');
                tableRef.current?.refetch();
            },
        });
    };

    const columns = [
        {
            title: 'Rua',
            key: 'street',
            render: (_, r) => `${r.street}, ${r.number}${r.complement ? ` - ${r.complement}` : ''}`,
        },
        {
            title: 'Bairro',
            dataIndex: 'neighborhood',
            key: 'neighborhood',
        },
        {
            title: 'Cidade / UF',
            key: 'city_state',
            render: (_, r) => `${r.city} / ${r.state}`,
        },
        {
            title: 'CEP',
            dataIndex: 'postal_code',
            key: 'postal_code',
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Space>
                    <Button size="small" icon={<EditOutlined/>} onClick={() => openEdit(record)}/>
                    <Button size="small" danger icon={<DeleteOutlined/>} onClick={() => handleDelete(record)}/>
                </Space>
            ),
        },
    ];

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.AUTH_ADDRESS_LIST}
                columns={columns}
                title="Meus Endereços"
                showSearch={false}
                buttonProps={{label: 'Novo Endereço', onClick: openCreate}}
            />

            <AddressModal
                open={modalOpen}
                record={editingRecord}
                onClose={handleClose}
                onSuccess={() => tableRef.current?.refetch()}
            />

            <ConfirmModalComponent/>
        </>
    );
}